module.exports = __webpack_public_path__ + "img/firm.680a08a2.png";